import { render, staticRenderFns } from "./vue-piczoom.vue?vue&type=template&id=88097ea6&scoped=true"
import script from "./vue-piczoom.vue?vue&type=script&lang=js"
export * from "./vue-piczoom.vue?vue&type=script&lang=js"
import style0 from "./vue-piczoom.vue?vue&type=style&index=0&id=88097ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88097ea6",
  null
  
)

export default component.exports